module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    ref: "workflowmodal",
    attrs: {
      "buttonText": "Add Workflow",
      "heading": "Add Workflow",
      "button-icon": "fa fa-plus",
      "button-size": "small",
      "button-style": "primary",
      "round": "",
      "plain": ""
    },
    on: {
      "save": _vm.addWorkflow
    }
  }, [_c('edit-workflow', {
    attrs: {
      "is-add": "",
      "row-data": _vm.formData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2129d8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/AddWorkflow.vue
// module id = 1702
// module chunks = 0